import { render } from "./DrWizardEndStep.vue?vue&type=template&id=b3704c7e&scoped=true"
import script from "./DrWizardEndStep.vue?vue&type=script&lang=js"
export * from "./DrWizardEndStep.vue?vue&type=script&lang=js"

import "./DrWizardEndStep.vue?vue&type=style&index=0&id=b3704c7e&scoped=true&lang=less"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3704c7e"]])

export default __exports__